// Mock data for Journeys N Tales luxury travel website

export const heroData = {
  headline: "Journeys N Tales",
  subheadline: "Bespoke Global Experiences, Curated Privately.",
  ctaText: "Begin Your Private Consultation",
  heroImage: "https://images.unsplash.com/photo-1551918120-9739cb430c6d"
};

export const pageHeroImages = {
  about: "https://images.unsplash.com/photo-1523496922380-91d5afba98a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB0cmF2ZWx8ZW58MHx8fHwxNzcxNDQyMDEzfDA&ixlib=rb-4.1.0&q=85",
  experiences: "https://images.pexels.com/photos/34777912/pexels-photo-34777912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  designJourney: "https://images.unsplash.com/photo-1572204443441-3859041b6c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwbGFuZSUyMHdpbmRvd3xlbnwwfHx8fDE3NzE1MDA3MTB8MA&ixlib=rb-4.1.0&q=85",
  contact: "https://images.pexels.com/photos/7635156/pexels-photo-7635156.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const philosophyData = {
  title: "Our Philosophy",
  content: "At Journeys N Tales, we believe that true luxury lies in the details only you would notice. Each journey we curate is a private masterpiece, designed around your desires, your pace, and your vision of perfection. We do not offer packages. We create experiences that exist only once—for you."
};

export const featuredDestinations = [
  {
    id: 1,
    name: "Maldives",
    tagline: "Overwater Serenity",
    description: "Private villas suspended above crystal waters, where luxury meets tranquility.",
    image: "https://images.pexels.com/photos/33607604/pexels-photo-33607604.jpeg"
  },
  {
    id: 2,
    name: "Santorini",
    tagline: "Aegean Elegance",
    description: "Cliffside villas with infinite views, where every sunset is a masterpiece.",
    image: "https://images.pexels.com/photos/17271499/pexels-photo-17271499.jpeg"
  },
  {
    id: 3,
    name: "Swiss Alps",
    tagline: "Alpine Grandeur",
    description: "Exclusive chalets nestled in pristine peaks, where silence speaks volumes.",
    image: "https://images.pexels.com/photos/14187938/pexels-photo-14187938.jpeg"
  },
  {
    id: 4,
    name: "Paris",
    tagline: "Timeless Sophistication",
    description: "Private suites in historic quarters, where elegance is a way of life.",
    image: "https://images.unsplash.com/photo-1679429685535-43d21f810968"
  },
  {
    id: 5,
    name: "Dubai",
    tagline: "Modern Opulence",
    description: "Sky-high luxury with bespoke experiences, where ambition meets artistry.",
    image: "https://images.pexels.com/photos/30115760/pexels-photo-30115760.jpeg"
  },
  {
    id: 6,
    name: "Bali",
    tagline: "Tropical Sanctuary",
    description: "Exclusive retreats surrounded by nature, where serenity becomes ritual.",
    image: "https://images.pexels.com/photos/8085318/pexels-photo-8085318.jpeg"
  }
];

export const signatureExperiences = [
  {
    id: 1,
    title: "Bespoke Global Journeys",
    description: "From the serene waters of Lake Como to the untamed beauty of Patagonia, we design journeys that reflect your unique vision of exploration.",
    image: "https://images.unsplash.com/photo-1586974726316-c6302de6a160",
    icon: "Plane"
  },
  {
    id: 2,
    title: "Destination Weddings",
    description: "Intimate celebrations in the world's most exclusive venues. From Tuscany to the Maldives, we orchestrate every detail with precision and grace.",
    image: "https://images.pexels.com/photos/33485955/pexels-photo-33485955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Chardham Heli Yatra",
    description: "Spiritual Journeys - Experience the divine Chardham circuit in unmatched comfort with private helicopter tours, luxury accommodations, and personalized spiritual guidance.",
    image: "https://images.pexels.com/photos/19271393/pexels-photo-19271393.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "Discover India - NRI Special",
    description: "Reconnect with your heritage. Curated luxury experiences across India—from Rajasthan's palaces to Kerala's backwaters, designed especially for NRI families.",
    image: "https://images.unsplash.com/photo-1644145886210-c52b5d9ef873?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMHBhbGFjZSUyMFRhaiUyME1haGFsJTIwaGVyaXRhZ2UlMjB0b3VyaXNtJTIwbHV4dXJ5fGVufDB8fHx8MTc3MTUwMjc3OXww&ixlib=rb-4.1.0&q=85",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Elite Golf Tours",
    description: "Play the world's most prestigious courses, from St Andrews to Augusta. Private access, expert caddies, and bespoke itineraries.",
    image: "https://images.unsplash.com/photo-1727122581898-0f049cae7e7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxlbGl0ZSUyMGdvbGYlMjBjb3Vyc2V8ZW58MHx8fHwxNzcxNTAxNzE2fDA&ixlib=rb-4.1.0&q=85",
    icon: "Trophy"
  },
  {
    id: 6,
    title: "Luxury Safaris",
    description: "Experience the wild in unparalleled luxury. From India's majestic tigers to Africa's Big Five, we curate exclusive wildlife adventures with private guides and luxury lodges.",
    image: "https://images.pexels.com/photos/14907418/pexels-photo-14907418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Sparkles"
  },
  {
    id: 7,
    title: "Luxury Cruises",
    description: "Private yacht charters and exclusive cruise experiences across the Mediterranean, Caribbean, and beyond.",
    image: "https://images.unsplash.com/photo-1562281302-809108fd533c",
    icon: "Anchor"
  },
  {
    id: 8,
    title: "Cultural & Global Events",
    description: "Access to the world's most coveted cultural moments—from Kyoto's cherry blossoms to exclusive film festivals and sporting events.",
    image: "https://images.unsplash.com/flagged/photo-1575356253609-f32f494b1a23",
    icon: "Sparkles"
  }
];

export const whyJntData = {
  title: "Why Journeys N Tales",
  reasons: [
    {
      title: "Personalised Consultation",
      description: "Every journey begins with understanding you",
      icon: "UserRound"
    },
    {
      title: "Global Network",
      description: "Exclusive access to the world's finest experiences",
      icon: "Globe"
    },
    {
      title: "End-to-End Management",
      description: "Seamless execution from concept to completion",
      icon: "CheckCircle"
    },
    {
      title: "Complete Discretion",
      description: "Your privacy is our highest priority",
      icon: "Shield"
    }
  ]
};

export const finalCtaData = {
  title: "Every extraordinary journey begins with a conversation.",
  ctaText: "Request a Private Consultation"
};

export const aboutData = {
  title: "About Journeys N Tales",
  sections: [
    {
      heading: "A Philosophy of Refinement",
      content: "Journeys N Tales was founded on a singular belief: that travel, at its finest, is an art form. We do not create itineraries. We craft narratives—private stories written in the language of discovery, comfort, and wonder."
    },
    {
      heading: "Global Partnerships, Local Expertise",
      content: "Our network spans six continents, connecting you with the world's most exclusive hotels, private estates, renowned chefs, expert guides, and cultural custodians. We know the places where true luxury resides—often beyond the reach of public eye."
    },
    {
      heading: "Bespoke by Design",
      content: "Every journey we design is singular. Whether you seek the tranquility of a private villa overlooking Lake Como, a family celebration across Rajasthan, or exclusive access to St Andrews, we tailor each detail to your vision."
    },
    {
      heading: "Discretion and Trust",
      content: "We understand that privacy is paramount. Your trust is our foundation, and every engagement is handled with the utmost confidentiality and care."
    }
  ],
  closingText: "At Journeys N Tales, we believe the world's greatest experiences are not found—they are created. Let us create yours."
};

export const experiencesData = [
  {
    id: 1,
    category: "Bespoke Global Journeys",
    description: "Whether you envision a cultural immersion in Japan, a wildlife expedition in Africa, or a leisurely exploration of Europe's hidden gems, we design journeys that honor your curiosity and style.",
    features: ["Private guides and curators", "Exclusive access to heritage sites", "Luxury accommodations handpicked for character", "Flexible itineraries that evolve with you"],
    image: "https://images.unsplash.com/photo-1654011905292-c342dd9fc433"
  },
  {
    id: 2,
    category: "Destination Weddings",
    description: "Your wedding day should be intimate, flawless, and uniquely yours. From Tuscan estates to Maldivian shores, we orchestrate celebrations that feel effortless and unforgettable.",
    features: ["Venue scouting and exclusive bookings", "Full event design and coordination", "Guest experience management", "Discreet on-ground support"],
    image: "https://images.unsplash.com/photo-1712314947761-a8d718bd8c32"
  },
  {
    id: 3,
    category: "Chardham Heli Yatra - Spiritual Journeys",
    description: "Experience the sacred Chardham circuit—Yamunotri, Gangotri, Kedarnath, and Badrinath—in unmatched comfort with private helicopter services. We handle every detail from luxury accommodations to spiritual guidance, ensuring a transformative pilgrimage.",
    features: ["Private helicopter charter for entire circuit", "VIP darshan arrangements at all four temples", "Luxury hotels and guesthouses", "Experienced spiritual guides and pundits", "Complete medical and safety support"],
    image: "https://images.pexels.com/photos/10432964/pexels-photo-10432964.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    category: "Discover India - NRI Special Experiences",
    description: "Designed exclusively for NRI families seeking to reconnect with their heritage. From exploring Rajasthan's magnificent palaces to Kerala's serene backwaters, experiencing the Taj Mahal at sunrise, or spiritual journeys through Varanasi—we curate authentic, luxury experiences across Incredible India.",
    features: ["Heritage palace and luxury resort stays", "Private cultural tours with expert historians", "Authentic culinary experiences", "Customized itineraries: Rajasthan, Kerala, Uttarakhand, Himachal Pradesh, Goa", "Family-friendly planning with multi-generational considerations"],
    image: "https://images.unsplash.com/photo-1675078483030-bebfeb180b90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxJbmRpYSUyMHBhbGFjZSUyMFRhaiUyME1haGFsJTIwaGVyaXRhZ2UlMjB0b3VyaXNtJTIwbHV4dXJ5fGVufDB8fHx8MTc3MTUwMjc3OXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    category: "Elite Golf Tours",
    description: "Play the courses you've only dreamed of. From the Old Course at St Andrews to Pebble Beach and beyond, we arrange access, expert caddies, and luxury accommodations.",
    features: ["Tee times at exclusive courses", "Private coaching and masterclasses", "Luxury stays at iconic golf resorts", "Customized multi-destination tours"],
    image: "https://images.unsplash.com/photo-1687291133565-767706032bed"
  },
  {
    id: 6,
    category: "Luxury Safaris",
    description: "Experience the wild in unparalleled luxury. From tracking Bengal tigers in India's Ranthambore to witnessing the Great Migration in Africa, we create exclusive wildlife adventures that combine thrill with comfort.",
    features: ["Private game drives with expert naturalists", "Luxury tented camps and lodges", "Access to exclusive wildlife reserves", "India (Ranthambore, Bandhavgarh, Jim Corbett) to Africa (Masai Mara, Serengeti, Kruger)"],
    image: "https://images.pexels.com/photos/35990296/pexels-photo-35990296.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 7,
    category: "Luxury Cruises",
    description: "Discover the world by sea aboard private yachts or the most exclusive cruise lines. From the Mediterranean to the Norwegian fjords, sail in unparalleled comfort.",
    features: ["Private yacht charters", "Curated shore excursions", "Onboard personalization", "Access to hidden coves and private islands"],
    image: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13"
  },
  {
    id: 8,
    category: "Cultural & Global Events",
    description: "Experience the world's most coveted moments—the Venice Biennale, Wimbledon, the Monaco Grand Prix, or a private tea ceremony in Kyoto. We provide access and context.",
    features: ["VIP access to global events", "Private tours of cultural landmarks", "Behind-the-scenes experiences", "Expert-led immersions"],
    image: "https://images.unsplash.com/photo-1717496376319-ee3d354ac2d8"
  }
];

export const contactData = {
  email: "journeysntales@gmail.com",
  phone: "+919717841166",
  address: "A 95 Adhchini, Main, Sri Aurobindo Marg, New Delhi, Delhi 110017",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=A+95+Adhchini+Sri+Aurobindo+Marg+New+Delhi+110017",
  googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.8284847847!2d77.20668!3d28.5426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMyJzMzLjQiTiA3N8KwMTInMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567890",
  socialMedia: {
    instagram: "https://www.instagram.com/journeysntalesdel/",
    facebook: "https://facebook.com/journeysntales",
    linkedin: "https://www.linkedin.com/in/pancaj-guptaa-557549195/"
  }
};

export const formSubmitMessage = {
  success: "Thank you for your interest in Journeys N Tales. Our team will respond within 24 hours to begin crafting your private journey.",
  error: "We apologize, but there was an issue submitting your inquiry. Please contact us directly at hello@journeysntales.com"
};
